// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InboundEmailSetup_inbound_text_container__iDgYe {
  display: flex;
  flex-direction: column;
  width: 800px;
}

.InboundEmailSetup_header_row__4oeBZ {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.InboundEmailSetup_btn_container__773Rp {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 5px;
}

.InboundEmailSetup_activate_btn__wgPsu {
  color: var(--color-theme-10) !important;
  border: 1px solid var(--color-theme-0) !important;
  width: 174px;
  height: 41px;
  font-weight: bold !important;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/InboundEmailSetup/InboundEmailSetup.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,iDAAiD;EACjD,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B","sourcesContent":[".inbound_text_container {\n  display: flex;\n  flex-direction: column;\n  width: 800px;\n}\n\n.header_row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.btn_container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding-top: 20px;\n  padding-bottom: 5px;\n}\n\n.activate_btn {\n  color: var(--color-theme-10) !important;\n  border: 1px solid var(--color-theme-0) !important;\n  width: 174px;\n  height: 41px;\n  font-weight: bold !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inbound_text_container": `InboundEmailSetup_inbound_text_container__iDgYe`,
	"header_row": `InboundEmailSetup_header_row__4oeBZ`,
	"btn_container": `InboundEmailSetup_btn_container__773Rp`,
	"activate_btn": `InboundEmailSetup_activate_btn__wgPsu`
};
export default ___CSS_LOADER_EXPORT___;
